<script lang="ts">
  import type { Orbit } from '$lib/types/launch';

  import { getFormatTime } from '$lib/utils/localeFormatter';
  import LabelValue from '../LabelValue.svelte';

  export let orbitParameters: Orbit;
  export let isSecondaryOrbit = false;
  export let secondaryOrbitTitle = '';

  function isSso(orbitType: number) {
    return orbitType == 1;
  }
</script>

{#if isSecondaryOrbit}
  <div class="mb-1">
    <span>SECONDARY ORBIT </span>
    <h2 class="card-title mb-1">
      {secondaryOrbitTitle}
    </h2>
  </div>
{/if}

{#if !isSso(orbitParameters.type)}
  {#if orbitParameters.eccentricity != null && orbitParameters.eccentricity > 0}
    <LabelValue label="Eccentricity">
      {orbitParameters.eccentricity}
    </LabelValue>
  {/if}
{/if}

{#if orbitParameters.ltdn}
  <LabelValue label="LTDN">
    {getFormatTime(orbitParameters.ltdn)}
  </LabelValue>
{/if}

<style>
  span {
    font-size: 1rem;
  }

  h2 {
    font-size: 1.6rem;
  }
</style>
